// extracted by mini-css-extract-plugin
export var container = "ProductContainer_container__-FoBD";
export var horRule = "ProductContainer_horRule__bQw8F hor-rule";
export var productContainer = "ProductContainer_productContainer__LiY-j";